import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { isResidential } from "@rentiohq/shared-frontend/dist/reduxV2/property/property.utils";
import {
  AMENITY_NAMES,
  getAmenityBooleanValue,
  getAmenityNumberValue,
  getAmenityStringValue,
} from "@rentiohq/shared-frontend/dist/reduxV2/propertyAmenity";
import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import {
  addYears,
  isBefore,
  startOfDay,
  subDays,
} from "@rentiohq/shared-frontend/dist/utils/date-fns.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { getAmountWithVat } from "@rentiohq/shared-frontend/dist/utils/number.utils";
import { EField, IExtraData } from "./schema.requestInsurance.types";

const NOW = new Date();

export const requestInsuranceValidationErrors = (params: {
  property: IProperty;
  contract: IContract;
}) => {
  const { property, contract } = params;

  const errors = [];

  // Only house or apartment is valid
  if (!isResidential(property)) {
    errors.push(getLocalizedText("insurance.validation.error.property_type"));
  }

  // Contract where end date is longer than a year from now is valid
  if (
    contract?.stopDate &&
    isBefore(
      startOfDay(contract.stopDate),
      startOfDay(subDays(addYears(NOW, 1), 1)),
    ) &&
    !contract.tacitRenewal
  ) {
    errors.push(getLocalizedText("insurance.validation.error.contract_length"));
  }

  return errors;
};

export const getInitialValues = (extraData: IExtraData): IValues => {
  const { propertyAmenities, contract } = extraData;

  return {
    [EField.ContractRentPrice]: getAmountWithVat(
      contract.currentPrice,
      (contract.priceVat || 0) / 100,
    ),
    [EField.BuildingSurfaceArea]: getAmenityNumberValue(
      propertyAmenities,
      AMENITY_NAMES.buildingSurfaceArea,
    ),
    [EField.BuildingLayers]: getAmenityNumberValue(
      propertyAmenities,
      AMENITY_NAMES.buildingFloorCount,
    ),
    [EField.BuildingAdjoined]: getAmenityStringValue(
      propertyAmenities,
      AMENITY_NAMES.buildingAdjoined,
    ),
    [EField.BuildingHasHardMaterials]:
      getAmenityBooleanValue(
        propertyAmenities,
        AMENITY_NAMES.buildingHasHardMaterials,
      ) || false,
  };
};
